"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M395.8,151.3c0,46-37.3,83.3-83.3,83.3s-83.3-37.3-83.3-83.3S266.5,68,312.5,68S395.8,105.3,395.8,151.3z M312.5,276.3 c-84.8,0-154.9,62.7-166.5,144.3c-1.8,12.6,8.1,23.9,20.9,23.9c61.2,0,230,0,291.2,0c12.7,0,22.7-11.3,20.9-23.9 C467.4,339.1,397.3,276.3,312.5,276.3z M91.9,246l-31.3-31.2c-8.1-8.1-21-8.1-29.2,0c-8.1,8.1-8.1,21,0,29.2l45.6,45.6 c8.1,8.1,21.2,8.1,29.4,0l75-74.8c8.1-8.1,8.1-21,0-29.2c-8.1-8.1-21-8.1-29.2,0L91.9,246z"
  });
};

exports.default = _default;